import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const fontSizeKeys = [
  'body-sm',
  'body-md',
  'body-lg',
  'label-sm',
  'label-md',
  'label-lg',
  'title-sm',
  'title-md',
  'title-lg',
  'headline-sm',
  'headline-md',
  'headline-lg',
  'inherit',
];

export const twMerge = extendTailwindMerge({
  classGroups: {
    'font-size': fontSizeKeys.map((key) => `text-${key}`),
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
